import styles from '~/styles/atoms/tab/tab.module.scss'
import TabItem, { TabItemVars } from '~/components/atoms/tab/TabItem'

export enum TabType {
  NORMAL,
  SUPPORT
}

export interface TabProps {
  items: TabItemVars[]
  onSelect(index: number): void
  selected?: number
  type?: TabType
}

const Tab = ({items, onSelect, selected = null, type = TabType.NORMAL}: TabProps) => {
  return (
    <ul className={styles.tab}>
      {items.map((item: TabItemVars, index) =>
        <TabItem<number>
          key={index}
          item={{...item, value: index}}
          onSelect={onSelect}
          selected={index == selected}
          type={type}
        />
      )}
    </ul>
  )
}

export default Tab